export default "__VITE_ASSET__rdRLwJhm__"